import { EcommerceAPI } from "../Client";

export const getAllSellerOrdersApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/orders/seller/list?page=${payload?.page || 0}&size=${
        payload?.size || 10
      }&search=${payload?.search || ""}&sortBy=${
        payload?.sortby || ""
      }&sortDir=${payload?.sortdir || ""}&orderStatus=${
        payload?.orderStatus || ""
      }`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCustomOrdersApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/custom-orders?page=${payload?.page || 0}&size=${
        payload?.size || 10
      }&sortBy=${payload?.sortBy || ""}&sortDir=${payload?.sortDir || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createCustomOrderApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/custom-orders`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadCustomOrderFileApi = async (payload) => {
  try {
    const formData = new FormData();

    payload?.files?.forEach((file) => {
      formData.append("files", file);
    });

    const response = await EcommerceAPI.post(`/custom-order/upload/file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateOrderStatusApi = async (payload) => {
  try {
    const requestBody = {
      status: payload?.status ?? 0,
      comments: payload?.comments || "",
      statusLabel: payload?.statusLabel || "",
    };
    const query = new URLSearchParams();

    if (payload?.orderItemId !== undefined && payload?.orderItemId !== null && payload?.orderItemId !== "") {
      query.append("orderItemId", payload.orderItemId);
    }

    if (payload?.orderId !== undefined && payload?.orderId !== null && payload?.orderId !== "") {
      query.append("orderId", payload.orderId);
    }

    const response = await EcommerceAPI.put(
      `/orders/status${query.toString() ? `?${query.toString()}` : ""}`,
      requestBody,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateRtoStatusApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/rto/update/status?rtoRequestId=${payload?.rtoRequestId || ""}&rtoItemId=${payload?.rtoItemId || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelRtoRequestApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/rto/request/cancel?rtoRequestId=${payload?.rtoRequestId || ""}&rtoItemId=${payload?.rtoItemId || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// export const getAllRtoRequestsApi = async () => {
//   try {
//     const response = await EcommerceAPI.get(`/rto/requests`);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

export const getAllRtoRequestsApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/rto/requests/seller?page=${payload?.page || 0}&size=${
        payload?.size || 10
      }&search=${payload?.search || ""}&sortBy=${
        payload?.sortby || ""
      }&sortDir=${payload?.sortdir || ""}&orderStatus=${
        payload?.orderStatus || ""
      }`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleRtoRequestApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/rto/request/${payload?.rtoRequestId || ""}?rtoRequestId=${payload?.rtoRequestId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createReturnShiprocketOrderApi = async (payload) => {
  try {  
    const response = await EcommerceAPI.post(
      `/create/return/shiprocket/order?rtoRequestId=${payload?.rtoRequestId || ""}&isSinglePackage=${payload?.isSinglePackage || false}&rtoItemId=${payload?.rtoItemId || ""}&needQC=${payload?.needQC || false}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createReplaceShiprocketOrderApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/create/replace/shiprocket/order?rtoRequestId=${payload?.rtoRequestId || ""}&isSinglePackage=${payload?.isSinglePackage || false}&rtoItemId=${payload?.rtoItemId || ""}&needQC=${payload?.needQC || false}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRtoCouriersListApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/rto/couriers/list?rtoRequestId=${payload?.rtoRequestId || ""}&rtoItemId=${payload?.rtoItemId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const shipRtoNowApi = async (payload) => {
  try {
    console.log("rto pay 3", payload);
    const response = await EcommerceAPI.post(
      `/rto/ship/now?courierCompanyId=${payload?.courierCompanyId || ""}&rtoRequestId=${payload?.rtoRequestId || ""}&rtoItemId=${payload?.rtoItemId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateRtoManifestApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/rto/manifests/generate?rtoRequestId=${payload?.rtoRequestId || ""}&rtoItemId=${payload?.rtoItemId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateRtoLabelApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/rto/label/generate?rtoRequestId=${payload?.rtoRequestId || ""}&rtoItemId=${payload?.rtoItemId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateRtoInvoiceApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/rto/invoice/generate?rtoRequestId=${payload?.rtoRequestId || ""}&rtoItemId=${payload?.rtoItemId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllOrdersApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/orders?page=${payload?.page || 0}&size=${payload?.size || 10}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// ship order start

export const createShiprocketOrderApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/create/shiprocket/order?orderId=${payload?.orderId || 0}&isSinglePackage=${payload?.isSinglePackage || false}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetCouriersListApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/couriers/list?orderId=${payload?.orderId || ""}&orderItemId=${payload?.orderItemId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const shipOrderApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/ship/now?courierCompanyId=${payload?.courierCompanyId || null}&orderItemId=${payload?.orderItemId || ""}&orderId=${payload?.orderId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelCustomerOrderApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/cancel/order?shipOrderId=${payload?.shipOrderId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// ship order end

export const printManifestOrderApi = async (payload) => {
  try {
    console.log("Payload ", payload);
    debugger;
    const response = await EcommerceAPI.post(
      `/manifests/generate?orderItemId=${payload?.orderItemId || ""}&orderId=${payload?.orderId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const printInvoiceOrderApi = async (payload) => {
  try {
    console.log("Payload ", payload);
    debugger;
    const response = await EcommerceAPI.post(
      `/invoice/generate?orderItemId=${payload?.orderItemId || ""}&orderId=${payload?.orderId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const printLabelOrderApi = async (payload) => {
  try {
    console.log("Payload ", payload);
    debugger;
    const response = await EcommerceAPI.post(
      `/label/generate?orderItemId=${payload?.orderItemId || ""}&orderId=${payload?.orderId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const magicImageUrlApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `v1/magic/image/presigned-url?fileName=${payload?.fileName || ""}&contentType=${payload?.contentType || ""}&orderItemId=${payload?.orderItemId || ""}&fileType=${payload?.fileType || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMagicImageUrlApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/single/video-image-map?orderItemId=${payload?.orderItemId || ""}&mapUploadID=${payload?.mapUploadID || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const videosMaPApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/${payload?.orderItemId}/videos/map?videouploadId=${payload?.videouploadId || 0}&imageUploadId=${payload?.imageUploadId}&mapUploadID=${payload?.mapUploadID}&orderItemId=${payload?.orderItemId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const mapOrderAPI = (orderItemId, payload) => {
  return EcommerceAPI.post(
    `/${orderItemId}/videos/map?videouploadId=${payload?.videouploadId}&mapUploadID=${payload?.mapUploadID}&imageUploadId=${payload?.imageUploadId}`,
    payload,
  )
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const fetchMagicAPI = () => {
  return EcommerceAPI.get(`/video-image-map`)
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const fetchAllMagicAPI = (payload) => {
  return EcommerceAPI.get(`/allorder/video-image-map/${payload?.customerId}`)
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const createVideoImageMapAPI = (payload) => {
  debugger;
  const shapeCodeMap = {
    none: 0,
    circle: 1,
    capsule: 2,
    hexagon: 3,
    rounded_rect: 4,
    star: 5,
    custom_template: 6,
  };
  const normalizedShape =
    typeof payload?.shape === "number"
      ? payload.shape
      : (shapeCodeMap[payload?.shape] ?? 0);
  return EcommerceAPI.post(
    `/videos/map?videouploadId=${payload?.videouploadId}&imageUploadId=${payload?.imageUploadId}&customerId=${payload?.customerId}&isQrMagic=${payload?.isQrMagic}&shape=${normalizedShape}`,
  )
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const deleteVideoImageMapAPI = (payload) => {
  return EcommerceAPI.delete(`/videos/map/${payload?.orderId}`)
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const updateVideoImageMapAPI = (payload) => {
  debugger;
  const shapeCodeMap = {
    none: 0,
    circle: 1,
    capsule: 2,
    hexagon: 3,
    rounded_rect: 4,
    star: 5,
    custom_template: 6,
  };
  const normalizedShape =
    typeof payload?.shape === "number"
      ? payload.shape
      : (shapeCodeMap[payload?.shape] ?? 0);
  return EcommerceAPI.put(
    `/videos/map?videouploadId=${payload?.videouploadId}&imageuploadId=${payload?.imageUploadId}&orderItemVideoMapId=${payload?.orderItemVideoMapId}&shape=${normalizedShape}`,
  )
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};
